import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    initialSize,
    selectNextPage,
    selectCanPreviousPage,
    setItemsPerPage,
    nextPage,
    previousPage,
    selectPage,
    selectTotal,
    setPage,
    selectSize
} from '../table/pagintaionSlice'
import _ from 'lodash'
import cn from 'classnames'

const Pagination = () => {
    const dispatch = useDispatch()

    const paginationTotal = useSelector(selectTotal)
    const paginationSize = useSelector(selectSize)
    const page = useSelector(selectPage)

    const canPreviousPage = useSelector(selectCanPreviousPage)
    const canNextPage = useSelector(selectNextPage)

    const onShowMore = (e) => {
        dispatch(setItemsPerPage(Number(paginationSize + 25)))
    }
    const onPerPageChange = (e) => {
        dispatch(setItemsPerPage(Number(e.target.value)))
    }

    const renderPageSelect = () => {
        if (paginationTotal > 1) {
            return (
                <div className="pagination__page-select">
                    <button
                        onClick={() => dispatch(previousPage())}
                        disabled={!canPreviousPage}
                        className="prev"
                    >
                        {
                            <svg
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z"
                                    fill="black"
                                />
                            </svg>
                        }
                    </button>
                    {_.range(1, paginationTotal + 1).map((_page) => (
                        <span
                            key={_page}
                            className={cn({ active: _page === page })}
                            onClick={() => dispatch(setPage(_page))}
                        >
                            {_page}
                        </span>
                    ))}
                    <button
                        onClick={() => dispatch(nextPage())}
                        disabled={!canNextPage}
                        className="next"
                    >
                        {
                            <svg
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z"
                                    fill="black"
                                />
                            </svg>
                        }
                    </button>
                </div>
            )
        }
    }

    const renderPerPageSelect = () => {
        return (
            <div className="pagination__per-page-select">
                <select defaultValue={initialSize} onChange={onPerPageChange}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                </select>
            </div>
        )
    }

    const renderShowMore = () => {
        if (paginationTotal > 1) {
            return (
                <button className="pagination__show-more" onClick={onShowMore}>
                    <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M14.1498 2.35C12.6998 0.9 10.7098 0 8.49977 0C4.07977 0 0.509766 3.58 0.509766 8C0.509766 12.42 4.07977 16 8.49977 16C12.2298 16 15.3398 13.45 16.2298 10H14.1498C13.3298 12.33 11.1098 14 8.49977 14C5.18977 14 2.49977 11.31 2.49977 8C2.49977 4.69 5.18977 2 8.49977 2C10.1598 2 11.6398 2.69 12.7198 3.78L9.49977 7H16.4998V0L14.1498 2.35Z"
                            fill="#EF4A3D"
                        />
                    </svg>
                    Показать еще
                </button>
            )
        }
    }

    return (
        <div className="pagination">
            {renderPerPageSelect()}
            {renderPageSelect()}
            {renderShowMore()}
        </div>
    )
}

export default Pagination
